import { createSlice } from "@reduxjs/toolkit";

const userRegistrationSlice = createSlice({
  name: "user-registration",
  initialState: {
    selfieModalClose: true,
    userClusterApiTrigger: true,
  },
  reducers: {
    setSelfieModalClose: (state, action) => {
      state.selfieModalClose = action.payload;
    },
    setUserClusterApiTrigger: (state, action) => {
      state.userClusterApiTrigger = !state.userClusterApiTrigger;
    },
  },
});

export const { setSelfieModalClose, setUserClusterApiTrigger } =
  userRegistrationSlice.actions;
export default userRegistrationSlice;
